import React, { useCallback, useEffect, useState } from 'react';

import './styles.css';

interface PaginatorProps {
  total: number;
  limit: number;
  offset: number;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
}

const Paginator: React.FC<PaginatorProps> = ({
  total,
  limit,
  offset,
  setOffset,
}) => {
  const [btnNb, setBtnNb] = useState(1);
  const [btnsArray, setBtnsArray] = useState([0]);
  const [activatedBtn, setActivatedBtn] = useState(0);

  useEffect(() => {
    const divisaoTotalLimit = parseFloat(Math.floor(total / limit).toFixed(0));
    const totalBtns =
      total % limit > 0 ? divisaoTotalLimit + 1 : divisaoTotalLimit;
    setBtnNb(totalBtns);
    setActivatedBtn(parseFloat(Math.floor(offset / limit).toFixed(0)));
  }, [total, offset, limit]);

  useEffect(() => {
    const pagesArray = Array.from(Array(btnNb).keys());
    if (btnNb > 5) {
      const numeroADireita = btnNb - (activatedBtn + 1);
      if (activatedBtn < 2) {
        setBtnsArray(pagesArray.slice(0, 5));
      } else if (numeroADireita < 2) {
        setBtnsArray(pagesArray.slice(activatedBtn - (4 - numeroADireita)));
      } else {
        setBtnsArray(pagesArray.slice(activatedBtn - 2, activatedBtn + 3));
      }
    } else {
      setBtnsArray(Array.from(Array(btnNb).keys()));
    }
  }, [btnNb, activatedBtn]);

  const goToNextPage = useCallback(() => {
    setOffset(offset + limit);
  }, [offset, limit, setOffset]);

  const goToPreviousPage = useCallback(() => {
    setOffset(offset - limit);
  }, [offset, limit, setOffset]);

  const goToPageNb = useCallback(
    (pageNb: number) => {
      setOffset(limit * pageNb);
    },
    [limit, setOffset]
  );

  return (
    <div className='paginator-container'>
      <button
        type='button'
        className='paginator-btn'
        disabled={activatedBtn === 0}
        onClick={() => goToPageNb(0)}
      >
        {'<<'}
      </button>
      <button
        type='button'
        className='paginator-btn'
        disabled={activatedBtn === 0}
        onClick={goToPreviousPage}
      >
        {'<'}
      </button>
      {btnsArray.map(btn => (
        <button
          key={btn}
          type='button'
          className={`paginator-btn ${
            btn === activatedBtn && 'paginator-btn-active'
          }`}
          onClick={() => goToPageNb(btn)}
        >
          {btn + 1}
        </button>
      ))}
      <button
        type='button'
        className='paginator-btn'
        disabled={activatedBtn + 1 === btnNb}
        onClick={goToNextPage}
      >
        {'>'}
      </button>
      <button
        type='button'
        className='paginator-btn'
        disabled={activatedBtn + 1 === btnNb}
        onClick={() => goToPageNb(btnNb - 1)}
      >
        {'>>'}
      </button>
    </div>
  );
};

export default Paginator;
